import React, { useEffect } from "react";
import BannerProjects from "./Body/BannerProjects";
import { validationLan } from "../../../ValidationLan/ValidationLan";

const Projects = () => {
  let isArabic = localStorage.getItem("lan") === "AR";
  useEffect(() => {
    validationLan();
  }, [isArabic]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <BannerProjects />;
};

export default Projects;
